export const QALITY_TEST_ISSUE_TYPE = 'QAlity Test';
export const dateFormat = 'DD/MM/YYYY';
export const longDateFormat = 'DD/MMM/YYYY';
export const DOCUMENTATION_LINK =
  'https://soldevelo.atlassian.net/wiki/spaces/QS/overview?homepageId=1631322237';

export const statusColors = {
  passed: '#8DCAAF',
  failed: '#F18C75',
  blocked: '#FFE381',
  inProgress: '#6091CC',
  unexecuted: '#DFE1E6',
};
